<template>
    <v-sheet height="100%">
        <v-container fluid class="b-container">
        <v-row
            no-gutters
            style="min-height: calc(100vh - 88px);"
            align="center"
        >
            <v-card flat max-width="500" class="mx-auto mb-12">
                <v-card-title class="red--text">
                    Forbidden Gateway
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <div class="subtitle-1 font-weight-bold text--primary">
                        {{ translations.noRights[lang] }}
                        <br />
                    </div>
                </v-card-text>
                <v-row no-gutters align="center" class="fill-height">
            <v-col class="text-center mb-12">
                <v-btn color="secondary" outlined class="mt-5" large @click="$router.go(-1)"
                    >{{ translations.goBack[lang] }}</v-btn
                >
            </v-col>
        </v-row>
            </v-card>
        </v-row>
    </v-container>
     
    </v-sheet>
</template>

<script>
import translations from "@/utils/translations/global";
export default {
    name: "Forbidden",
    mixins: [translations],

    computed: {
        lang() {
            return this.$route.params.lang;
        }
    },

    beforeCreate() {
        const lang = this.$route.path.slice(0, 4);
        if (lang !== "/el/" && lang !== "/en/" && lang !== "/it/") {
            this.$router.replace("/en" + this.$route.fullPath);
        }
    }
};
</script>
